import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.set.js";
import "core-js/modules/web.dom-collections.iterator.js";
import serverList from "../../../components/serverList/serverOptions.vue";
import { saveRoleClear } from "@/api/roleClear";
export default {
  components: {
    serverList: serverList
  },
  data: function data() {
    return {
      roleListStr: "",
      form: {}
    };
  },
  created: function created() {},
  methods: {
    summit: function summit() {
      var _this = this;
      if (!this.form.server_id) {
        this.$message({
          message: "请选择服务器",
          type: "warning"
        });
        return;
      }
      if (this.form.apply_reason) {
        this.form.apply_reason = this.form.apply_reason.trim();
      }
      if (!this.form.apply_reason) {
        this.$message({
          message: "请输入申请原因",
          type: "warning"
        });
        return;
      }
      this.form.role_list = this.roleListStr.split(',');
      for (var i = 0; i < this.form.role_list.length; i++) {
        this.form.role_list[i] = this.form.role_list[i].trim();
      }
      this.form.role_list = this.form.role_list.filter(function (item) {
        return item;
      });
      // 去重复
      this.form.role_list = Array.from(new Set(this.form.role_list));
      saveRoleClear(this.form).then(function (res) {
        if (res.code === 0) {
          _this.$message({
            message: "提交成功",
            type: "success"
          });
          _this.$emit("close");
        }
      });
    },
    initData: function initData(data) {
      console.info(data.id);
      this.roleListStr = data.role_list;
      this.form = {
        id: data.id,
        server_id: data.server_id,
        apply_reason: data.apply_reason
      };
    }
  }
};